import request, { baseURL } from "@shared/utils/axios";
import type { IMeParams, IUserData } from "../types";
import axios from "axios";

export async function login(data: {
  username: string;
  password: string;
}): Promise<{ refresh: string; access: string }> {
  return await request({
    url: "/account/me/",
    method: "post",
    data,
  });
}

export async function register(data: {
  first_name?: string;
  last_name?: string;
  image?: number;
  description?: string;
  username: string;
  password: string;
}) {
  return await request({ url: "account/users/", method: "post", data });
}

export async function getMe(): Promise<IUserData> {
  return await request({
    url: "/account/users/me/",
    method: "get",
  });
}

export async function refreshToken(data: {
  refresh: string;
}): Promise<{ access: string; refresh: string }> {
  return await axios.post(baseURL + "/account/users/auth/refresh/", data);
}

export async function updateMe(data: IMeParams): Promise<any> {
  return await request({
    url: "/account/users/me/",
    method: "patch",
    data,
  });
}
